import { Stack } from '@mui/material';
import ArticleMeta from '../../types/ArticleMeta';
import NoAccessView from '../ErrorViews/NoAccessView';
import ComingSoonInfo from './ComingSoonInfo';

interface NotificationsAreaProps {
  readonly meta: ArticleMeta;
  readonly restricted?: boolean;
}
export default function NotificationsArea({
  meta,
  restricted,
}: NotificationsAreaProps) {
  if (!restricted && !meta.isUpcoming) {
    return <></>;
  }

  return (
    <Stack
      direction='column'
      useFlexGap
      spacing={1.25}
      sx={{
        marginBottom: { xs: 3, sm: 0 },
        marginTop: { xs: 0, sm: 3 },
      }}
    >
      {restricted && <NoAccessView />}
      {meta.isUpcoming && <ComingSoonInfo />}
    </Stack>
  );
}
